
import { useEffect, useState } from "react";
import "./standard-question.component.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faFolderBlank, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Question, QuestionLanguage } from "../../model/questions-summary.model";
import tokenService from "../../services/token.service";
import { deleteStandardAssessment, getStandardAssessment, putStandardAssessment, updateStandardAssessment } from "../../services/api.service";
import CreateStdAssessmentModal from "../../modal/create-std-assessment.modal";
import { Button } from "react-bootstrap";
import { FormControl, List, TextField } from "@mui/material";
import CreateStdAssessmentAIModal from "../../modal/create-std-assessment-ai.modal";
import { useNavigate } from "react-router-dom";
import AI_ICON from "../../assets/images/ai-icon.png";
import NO_QUESTIONS_ICON from "../../assets/images/no-questions.png";
import TRASH_ICON from "../../assets/images/trash.png";
import EDIT_ICON from "../../assets/images/edit-icon.png";
import InfoGeneralModal from "../../modal/info-general.modal";

const StandardQuesstionComponent = () => {
    const [open, setOpen] = useState(false);
    const [openCreatewithAI, setOpenCreatewithAI] = useState(false);
    const [questions, setQuestions] = useState<Question[]>([]);
    const [isMaxQuestion , setIsMaxQuestion] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        if (tokenService.getHR9CompanyUUID()) {
            getAllSTd();
        }
    }, [])
    const onSubmit = (newQuestion) => {
        const questionList = [...questions];
        if (!Array.isArray(questions)) {
            questionList.push(newQuestion);
        } else {
            questionList.push(newQuestion);

        }
        const questionsBody = {
            questions: questionList
        };
        putStandardAssessment(tokenService.getHR9CompanyUUID(), questionsBody).then((res) => {
            if (res.data.is_success) {
                getAllSTd();
                setOpen(false);
            }
            console.log(res.data)
        })

    }

    const getAllSTd = () => {
        getStandardAssessment(tokenService.getHR9CompanyUUID()).then((res) => {

            if (res.data.is_success) {
                const questionResult = res.data.message as Question[];
                questionResult.map((item, index) => {

                    questionResult[index].is_edit = false;
                })
                setQuestions(questionResult);
                console.log(res.data);
            }
        })
    }

    const onAddQuestion = (questionMod: Question[], url, total_amount) => {
        navigate(`/${tokenService.getHR9CompanyUUID()}/company-questions-management/create-from-url`,
            { state: { url, total_amount, questions: questionMod, total_question: questions.length } })
    }

    const onAddQuestionNormal = () => {
        navigate(`/${tokenService.getHR9CompanyUUID()}/company-questions-management/create-from-url`,
            { state: { total_question: questions.length } })
    }

    const handleClosePopup = () => {
        setOpen(false);
    }
    const clickCreateFromUrl = () => {
        setOpenCreatewithAI(true);
    }
    const handleOpen = () => { setOpen(true) }

    const onDeleteQuestion = (item: Question) => {
        deleteStandardAssessment(tokenService.getHR9CompanyUUID(), item.question_id).then((res) => {
            if (res.data.is_success) {
                getAllSTd();
            }
        })
    }

    const onUpdateQuestion = (item: Question) => {

        updateStandardAssessment(tokenService.getHR9CompanyUUID(), item.question_id, { th: item.question.th, en: item.question.en }).then((res) => {
            if (res.data.is_success) {
                getAllSTd();
            }
        })
    }
    const handleUpdateQuestion = (index: number, field: keyof QuestionLanguage, value: string) => {
        if (questions) {
            const updatedQuestions = [...questions];
            updatedQuestions[index].question[field] = value;
            setQuestions(updatedQuestions);
        }
    };
    const onEditMode = (index) => {
        if (questions) {
            const updatedQuestions = [...questions];
            updatedQuestions[index].is_edit = true;
            setQuestions(updatedQuestions);
        }
    }

    const handleMaxQuestion = () => {
        setIsMaxQuestion(!isMaxQuestion);
    }

    return (
        <>
            <div className="std-asm-control">
                <div className="border-std std-asm-top-control">
                    <div className="std-asm-top-text-control">
                        <span className="std-asm-top-title">จัดการคำถามพื้นฐานขององค์กร</span>
                        <span className="std-asm-top-desc">คำถามพื้นฐานขององค์กรสร้างได้สูงสุด 10 คำถาม และจะถูกนำไปใช้เมื่อสร้างชุดคำถามสัมภาษณ์</span>
                    </div>
                   
                            <div className="std-asm-add-button-control">

                                <Button className="button-std std-asm-add-button" onClick={questions.length >= 10 ? handleMaxQuestion : clickCreateFromUrl}>
                                    <img src={AI_ICON} className="icon"></img>
                                    สร้างคำถามด้วย AI
                                </Button>
                                <Button className="button-std std-asm-add-button" onClick={questions.length >= 10 ? handleMaxQuestion : onAddQuestionNormal}>
                                    เพิ่มคำถาม
                                </Button>
                            </div>
                       
                </div>

                <div className="std-asm-content-control">

                    {
                        questions && questions.length > 0 ?
                            <div className="std-asm-list-control">
                                {questions.map((item, index) => {

                                    return (
                                        item.is_edit ?
                                            <div className="border-std create-std-ai-question-list-item" key={index}>
                                                <div className="create-std-form-control">
                                                    <div className="create-std-topic-control">
                                                        <span className="create-std-form-label">คำถามที่ {Number(index + 1)}</span>
                                                        <img src={TRASH_ICON} className="icon-delete"
                                                            onClick={() => onDeleteQuestion(item)}></img>
                                                    </div>
                                                    <FormControl
                                                        key={index}
                                                        className={item.question.th ? `input-std create-std-form` : `input-std create-std-form input-error`}
                                                        fullWidth
                                                    >
                                                        <TextField
                                                            margin="dense"
                                                            fullWidth
                                                            variant="outlined"
                                                            label="คำถามภาษาไทย"
                                                            value={item.question.th}
                                                            onChange={(e) => handleUpdateQuestion(index, "th", e.target.value)}
                                                        />
                                                    </FormControl>
                                                </div>

                                                {/* English Question Field */}
                                                <div className="create-std-form-control">
                                                    <FormControl
                                                        key={index}
                                                        className={item.question.en
                                                            ? `input-std create-std-form` : `input-std create-std-form input-error`}
                                                        fullWidth
                                                    >
                                                        <TextField
                                                            margin="dense"
                                                            fullWidth
                                                            variant="outlined"
                                                            label="คำถามภาษาอังกฤษ"
                                                            value={item.question.en}
                                                            onChange={(e) => handleUpdateQuestion(index, "en", e.target.value)}
                                                        />
                                                    </FormControl>

                                                </div>
                                                <Button className="button-std button-submit" onClick={() => onUpdateQuestion(item)}>บันทึก</Button>
                                            </div> :
                                            <div className="border-std std-list-item-control" key={index}>
                                                <div className="std-list-item-content-control">
                                                    <span className="std-list-item-text-number">{`คำถามที่ ${index + 1}:`}</span>
                                                    <div className="std-list-item-text-control">
                                                        <span className="std-list-item-desc-bold">{item.question.th}</span>
                                                    </div>

                                                    <div className="std-list-item-text-control">
                                                        <span className="std-list-item-desc">{item.question.en}</span>
                                                    </div>

                                                    <div className="std-list-item-text-email-control">
                                                        <span className="std-list-item-desc">สร้างโดย: {item.created_by}</span>
                                                    </div>
                                                </div>
                                                <div className="std-list-action-control">
                                                    <img src={EDIT_ICON} className="std-list-delete-icon" onClick={() => onEditMode(index)}>
                                                    </img>
                                                    <img src={TRASH_ICON} className="std-list-delete-icon"
                                                            onClick={() => onDeleteQuestion(item)}></img>
                                                </div>
                                            </div>
                                    )
                                })}

                            </div> : <div className="std-no-questions-control">
                                <div className="std-no-questions-content">
                                    <img src={NO_QUESTIONS_ICON} className="icon"></img>
                                    <span className="text">ยังไม่มีคำถามพื้นฐานขององค์กร</span>

                                </div>
                            </div>

                    }

                </div>





            </div>

            {
                open && <CreateStdAssessmentModal isOpen={open} onClose={handleClosePopup} onSubmitQuestion={onSubmit}></CreateStdAssessmentModal>
            }

            {
                openCreatewithAI && questions.length < 10 && <CreateStdAssessmentAIModal
                    totalQuestion={questions ? questions : []}
                    onAddQuestion={onAddQuestion}
                    isOpen={openCreatewithAI}
                    onClose={() => setOpenCreatewithAI(false)}></CreateStdAssessmentAIModal>
            }
            {
                isMaxQuestion && <InfoGeneralModal isOpen={isMaxQuestion} 
                onClose={handleMaxQuestion}
                message={"อุ๊ซซซซ"} message2={"คำถามพื้นฐานของคุณได้ถึงขีดจำกัดแล้ว"}  icon={NO_QUESTIONS_ICON}></InfoGeneralModal>
            }

        </>
    )
}

export default StandardQuesstionComponent;